<template>
  <div style="display: flex; align-items: center;">
    <span v-if="label" class="primary--text pr-2 fs18 fw700">{{label}}</span>
    <svg style="width: 50px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 25 100 50">
      <circle :fill="$vuetify.theme.primary" cx="16.1" cy="50" r="8.3" class="undefined"/>
      <circle :fill="$vuetify.theme.primary" cx="44.4" cy="50" r="10.9" class="undefined"/>
      <path :fill="$vuetify.theme.primary" d="M91 47.9L69.7 35.6c-1.6-0.9-3.6 0.2-3.6 2.1v24.6c0 1.9 2 3 3.6 2.1L91 52.1C92.6 51.2 92.6 48.8 91 47.9z" class="undefined"/>
    </svg>
  </div>
</template>

<script>
    export default {
      props: {
        label: {
          type: String,
          required: false
        }
      }
    }
</script>
